<template>
  <div id="games">
    <div class="header">
      <div class="header_section">
        <router-link to="/profile" class="header_icone header_element">
          <!--          <span class="icon icon-left-arrow icon-lg"></span>-->
          <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>

        </router-link>
        <h1 class="header_element">Games</h1>
      </div>
    </div>
    <div class="content_container">
      <div class="order-list">
        <div class="order" v-for="(order,key) in data" :key="key" :id="order.order_id">
          <h3>{{ order.order_name }}</h3>
          <div class="game-list">
            <a :href="'/jeu/'+game.id" class="game" v-for="(game,key) in order.games" :key="key" :id="game.id">
              <div class="picture"><img :src="'img/'+game.imgUrl" alt=""></div>
              <div class="content"><h4>{{ game.name }}</h4>
                <font-awesome-icon color="#FFF" icon="angle-right"/>
              </div>

            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import mapActions from "vuex/dist/vuex.mjs";

export default {
  name: "Games",
  data() {
    return {
      data: [
        {
          order_id: 1,
          order_name: "Test",
          games: [
            {
              id: 1,
              name: "Jeux",
              imgUrl: 'logo.png',
            },
            {
              id: 2,
              name: "Jeu",
              imgUrl: 'logo.png',
            },
          ]
        },
        {
          order_id: 1,
          order_name: "Test",
          games: [
            {
              id: 1,
              name: "Jeux",
              imgUrl: 'logo.png',
            }
          ]
        },
      ]
    }
  },
  methods: {
    // ...mapActions(['getGames'])
  },
  mounted() {

  },


}
</script>

<style scoped>
a:hover {
  text-decoration: none;
  color: #fff;
}

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}


.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.header_section {
  display: flex;
  align-items: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}


.content_container {
  padding: 0 20px;
  overflow: scroll;
  height: 80vh;
}

.order-list {
  width: 80%;
  margin: auto;
}

.order {
  padding: 20px;
  margin: 10px;
}

.order:nth-child(-n +1) {

  border-bottom: 2px solid var(--main-color);
}

.game-list {
  display: flex;
  padding: 20px;
}

.game {
  width: 45%;
  margin: 10px;
  display: flex;
  align-items: center;
  align-content: center;
  border-radius: 10px;
  background: #00a6d9;
  border: 1px solid #00a6d9;
  transition: .3s;
}

.game .picture {
  flex: 1;
  display: flex;
  background: #fff;
  align-content: center;
  align-items: center;
  padding: 5px;
  border-radius: 8px 0 0 8px;
}

.game .picture img {
  width: 100%;
}

.game .content {
  flex: 3;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.game:hover {
  filter: brightness(80%);
  box-shadow: 1px 1px 8px #7f929a;
}
</style>
